import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-developer">
          <span className="footer-developer-name">TrillionsTechSolutions</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

